import { createContext, useContext } from 'react'
import type { AgentSuggestion, AgentWelcomeText } from './AgentSuggestions'

interface AgentSuggestionsContextValue {
  suggestions: AgentSuggestion[]
  welcomeText: AgentWelcomeText
}

export const AgentSuggestionsContext = createContext<AgentSuggestionsContextValue>({
  suggestions: [],
  welcomeText: { title: 'Hello there!', description: '' },
})

export function useAgentSuggestions() {
  return useContext(AgentSuggestionsContext)
}
